import { render, staticRenderFns } from "./AddSubtitle.vue?vue&type=template&id=d82d08fe&scoped=true&"
import script from "./AddSubtitle.vue?vue&type=script&lang=js&"
export * from "./AddSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82d08fe",
  null
  
)

export default component.exports